import * as React from 'react';
import { GroupChart, PVANav, PVASelect, LoadingIndicator, PVAContentHeader, PVAContentBody } from '../../../components';
import { ReportType, MidRangeType } from '../../../enums';
import { ReportDataService, UserDataService, SecondaryReportDataService } from '../../../services';
import { SurveyNote, SecondaryReport } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { UserStore, FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';

interface ReportState {
    selectedUserData: any;
    reportType: ReportType;
    midRangeType: MidRangeType;
    sticky: boolean;
    stickySize: number;
    stickyGroups: number[];
    groupPos: number[];
    activeInd: number;
    orgId: number;
    userId?: number;
    surveyVersionId: number;
    loading: boolean;
    open: boolean;
    notes: SurveyNote[];
    workingNote: string;
    showNotes: boolean;
    private: boolean;
    secondaryReport: SecondaryReport | undefined;
    loadedReportId: number;
}

interface ReportProps extends BaseRouteProps<{id: number}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class Report extends React.Component<ReportProps, ReportState> {
    private userDataService = new UserDataService(this.props.notificationService);
    private reportDataService = new ReportDataService(this.props.notificationService);
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);
    private banner: any;
    private pageTop: any;
    private groupEls: any[];
    // private timer: any;

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get userCanSeeRIandRB() {
        return this.props.UserStore!.checkUserPermission('viewResponseIndicatorsAndBreakdown')
            || this.props.UserStore!.userRoleIn(['superAdmin', 'siteAdmin', 'ponderaAssociate']);
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    constructor(props: ReportProps) {
        super(props);

        this.groupEls = [];

        this.state = {
            selectedUserData: null,
            reportType: ReportType.Standard,
            midRangeType: MidRangeType.Default,
            sticky: false,
            stickySize: 0,
            stickyGroups: [],
            groupPos: [],
            activeInd: -1,
            orgId: 0,
            surveyVersionId: 0,
            userId: undefined,
            loading: true,
            open: false,
            notes: [],
            workingNote: '',
            showNotes: false,
            private: true,
            secondaryReport: undefined,
            loadedReportId: -1
        };
    }

    private updateReport() {
        var userId = this.state.userId;

        if (this.survey && this.surveyVersion && userId && this.state.secondaryReport) {
            this.setState({
                loading: true
            });
            this.reportDataService.getIndividualReportDataByReport(this.state.secondaryReport, userId || undefined, this.surveyVersion.id).then((reportData) => {
                // this.props.FilterStore!.individualReportUserData = reportData;
                // this.props.FilterStore!.individualReportUserId = userId;

                var stickyGroups: number[] = [];
                var groupPos: number[] = [];
                reportData.inclinationGroups.map((data: any, ind: number) => {
                    stickyGroups[ind] = 0;
                    groupPos[ind] = 0;
                });
                this.setState({
                    selectedUserData: reportData,
                    stickyGroups: stickyGroups,
                    groupPos: groupPos,
                    loading: false
                });

                if (userId) {
                    this.userDataService.getNotes(userId).then((notes: SurveyNote[]) => {
                        this.setState({
                            notes: notes
                        });
                    });
                }
            });
        } else if (this.survey && this.surveyVersion && this.state.secondaryReport) {
            this.setState({
                loading: true
            });
            this.reportDataService.getIndividualReportStructureDataByReport(this.state.secondaryReport).then((reportData) => {
                var stickyGroups: number[] = [];
                var groupPos: number[] = [];
                reportData.inclinationGroups.map((data: any, ind: number) => {
                    stickyGroups[ind] = 0;
                    groupPos[ind] = 0;
                });
                this.setState({
                    selectedUserData: reportData,
                    stickyGroups: stickyGroups,
                    groupPos: groupPos,
                    loading: false
                });
            });
        }
    }

    private updateOrganization() {
        if (this.organization !== null && this.state.orgId !== this.organization.id) {
            var orgId = this.organization.id;
            this.setState(
                {
                    orgId: orgId,
                    notes: [],
                    selectedUserData: undefined,
                    userId: undefined
                }, 
                this.updateReport);

            return true;
        }
        return false;
    }

    private update() {
        
        if (this.state.loadedReportId !== this.props.match.params.id) {
            this.secondaryReportDataService.get(this.props.match.params.id).then((report: SecondaryReport) => {
                this.setState(
                    {
                        secondaryReport: report,
                        loadedReportId: this.props.match.params.id
                    }, 
                    this.updateReport);
            });
        }

        if (this.userRole !== 'user') {
            if (this.surveyVersion !== null && this.state.surveyVersionId !== this.surveyVersion.id) {
                this.setState({
                    surveyVersionId: this.surveyVersion.id
                });

                if (!this.updateOrganization()) {
                    this.updateReport();
                }
            } else {
                this.updateOrganization();
            }
        }

        if (this.state.secondaryReport && this.surveyVersion && this.state.secondaryReport.surveyVersionID !== this.surveyVersion.id) {
            this.props.history.push('/home');
        }
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    updateNav() {
        // if (this.timer) {
        //     clearTimeout(this.timer);
        // }

        // this.timer = setTimeout(
        //     () => {
                var stick = this.state.stickySize;

                if (this.banner && this.state.stickySize === 0) {
                    this.setState({
                        stickySize: this.banner.offsetTop
                    });
                    stick = this.banner.offsetTop;
                }

                var sticky = stick;
                var markSticky = false;

                if (this.pageTop.scrollTop >= sticky) {
                    markSticky = true;
                } else {
                    markSticky = false;
                }

                var stickies = this.state.stickyGroups;
                var i: number = 0;
                var activeInd: number = -1;
                if (this.state.sticky) {
                    for (; i < this.groupEls.length; i++) {
                        if (this.state.groupPos[i] === 0 && this.groupEls[i]) {
                            this.state.groupPos[i] = this.groupEls[i].offsetTop;
                        }
                        stickies[i] = 0; // white
                        if (this.state.groupPos[i] !== 0) {
                            if (this.pageTop.scrollTop >= this.state.groupPos[i] - 250) {
                                stickies[i] = 1; // active
                                activeInd = i;
                                for (var t: any = 0; t < i; t++) {
                                    stickies[t] = 2; // past
                                }
                            }
                        }
                    }
                } else {
                    for (; i < this.groupEls.length; i++) {
                        stickies[i] = 0;
                    }
                }

                this.setState({
                    stickyGroups: stickies,
                    activeInd: activeInd,
                    sticky: markSticky
                });
        //     },
        //     1
        // );
    }

    handleScroll(event: any, t: any) {
        if (event.target.getAttribute('class') !== 'site-content-inner') {
            return;
        }
        this.updateNav();
    }

    @computed get organizationName() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return `${this.props.FilterStore!.organization!.name}`;
        }
        return '';
    }
    
    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get teamID() {
        if (this.props.FilterStore && this.props.FilterStore.teamId) {
            return this.props.FilterStore.teamId;
        }
        return undefined;
    }

    public userChange(e: any) {
        var userId: number = Number(e.target.value);
        this.setState({
            userId: userId,
            loading: true
        });

        this.props.FilterStore!.individualReportUserId = userId;

        if (this.userRole !== 'user') {
            // var surveyVersionId: number = 0;
            // if (this.state.surveyVersionId !== 0) {
            //     surveyVersionId = this.state.surveyVersionId;
            // }

            if (this.survey && userId && this.state.secondaryReport) {
                this.reportDataService.getIndividualReportDataLatestByReport(userId, this.state.secondaryReport, this.surveyVersion ? this.surveyVersion.id : undefined).then((reportData: any) => { // this.survey.id, userId, surveyVersionId
                    var stickyGroups: number[] = [];
                    var groupPos: number[] = [];
                    reportData.inclinationGroups.map((data: any, ind: number) => {
                        stickyGroups[ind] = 0;
                        groupPos[ind] = 0;
                    });
                    this.setState({
                        selectedUserData: reportData,
                        stickyGroups: stickyGroups,
                        groupPos: groupPos,
                        loading: false
                    });

                    if (userId) {
                        this.userDataService.getNotes(userId).then((notes: SurveyNote[]) => {
                            this.setState({
                                notes: notes
                            });
                        });
                    }
                });
            } else if (this.surveyVersion && this.state.secondaryReport) {

                this.reportDataService.getIndividualReportStructureDataByReport(this.state.secondaryReport).then((reportData) => {
                    var stickyGroups: number[] = [];
                    var groupPos: number[] = [];
                    reportData.inclinationGroups.map((data: any, ind: number) => {
                        stickyGroups[ind] = 0;
                        groupPos[ind] = 0;
                    });
                    this.setState({
                        selectedUserData: reportData,
                        stickyGroups: stickyGroups,
                        groupPos: groupPos,
                        loading: false,
                        notes: []
                    });
                });
            }
        }
    }
    
    private GetTeamID() {
        var result = this.teamID;
        if (result && result > 0) {
            return result;
        }
        if (this.state.selectedUserData) {
            return this.state.selectedUserData.teamID;
        }
        return undefined;
    }

    private ActionsButton(sticky: boolean) {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${(this.state.open && (((sticky && this.state.sticky)) || (!sticky && !this.state.sticky))) ? 'open' : ''}`}>
                    {this.state.reportType === ReportType.Midrange && <li className="options-header">Mid Range Options</li>}
                    {this.state.reportType === ReportType.Midrange && <li className="options-entry">      
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-list-alt" /> <span> Use Mid Ranges From</span>
                        </div>              
                        <select className="form-control" onChange={(e) => { this.setState({midRangeType: parseInt(e.target.value, 10), open: !this.state.open}, this.forceUpdate); }}>
                            <option selected={this.state.midRangeType === MidRangeType.Default} value={MidRangeType.Default}>PVA</option>
                            <option selected={this.state.midRangeType === MidRangeType.Team} value={MidRangeType.Team}>Current Team</option>
                            <option selected={this.state.midRangeType === MidRangeType.Organization} value={MidRangeType.Organization}>Current Organization</option>
                            <option selected={this.state.midRangeType === MidRangeType.All} value={MidRangeType.All}>All PVA Data</option>
                        </select>
                    </li>}
                    <li className="options-header">Change View</li>
                    {this.state.reportType !== ReportType.Standard && <li className="options-entry" onClick={(e) => this.setState({reportType: ReportType.Standard, showNotes: false, open: false})}>
                        <div className="options-entry-title">
                            <img src="/images/standardIcon.svg" />
                            <span> Standard View</span>
                        </div>
                        <div className="options-entry-desc">
                            Lorem ipsum solet dolor set amet tulus mes colet feris ales quandrat per loris merin.
                        </div>
                    </li>}
                    {this.state.reportType !== ReportType.Midrange && <li className="options-entry" onClick={(e) => this.setState({reportType: ReportType.Midrange, showNotes: false, open: false})}>
                        <div className="options-entry-title">
                            <img src="/images/midrangeIcon.svg" />
                            <span> Mid Range View</span>
                        </div>
                        <div className="options-entry-desc">
                        Lorem ipsum solet dolor set amet tulus mes colet feris ales quandrat per loris merin.
                        </div>
                    </li>}
                    {(this.userRole === 'siteAdmin' || this.userRole === 'superAdmin') && <li className="options-entry" onClick={(e) => this.setState({showNotes: true, open: false})}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-edit" /> <span> Notes</span>
                        </div>
                        <div className="options-entry-desc">
                            Lorem ipsum solet dolor set amet tulus mes colet feris ales quandrat per loris merin.
                        </div>
                    </li>}
                    <li className="options-header">Export Options</li>
                    <li className="options-entry">
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-save-file" /> <span> PDF Export</span>
                        </div>
                        <div className="options-entry-desc">
                            Lorem ipsum solet dolor set amet tulus mes colet feris ales quandrat per loris merin.
                        </div>
                    </li>
                </ul>
        </div>);
    }

    public render() {
        var defaultOptions = [{
            id: 0,
            value: '- Clear Selected -'
        }];

        var resultGroups = <div />;
        if (!this.state.loading && this.state.selectedUserData) {
            var indexOffset = 0;
            resultGroups = (
                <div>
                    {this.state.selectedUserData.inclinationGroups.filter((x: any) => {
                        if (!this.surveyReportType) {
                            return true;
                        }
                        return x.surveyReportTypeID === this.surveyReportType.id;
                    }).map((groupData: any, index: any) => {
                        var chart = <div key={`chart-${index}`} ref={(e) => this.groupEls[index] = e}>
                            <GroupChart teamID={this.GetTeamID()} style={this.getUserStyle()} groupData={groupData} reportType={this.state.reportType} midRangeType={this.state.midRangeType} index={index} offset={indexOffset} allowToggle={this.userPermissions.indexOf('scoreBarColorChange') > -1} />
                        </div>;
                        indexOffset += groupData.data.length;
                        return chart;
                    })}
                </div>);
        }

        var contentHeaderSmall = (
            <div className="row">
                <div className="col-sm-6 col-md-8 col-xs-12">
                    <div className="title">
                        {this.state.secondaryReport && this.state.secondaryReport.name} <span className="light">for </span>
                        <PVASelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.userChange(e)} />
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 text-right">
                    {this.ActionsButton(true)}
                </div>
            </div>);

        return (
            <div className="site-content-inner" ref={(e) => this.pageTop = e} onScroll={(e) => this.handleScroll(e, this)}>

                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}
                {this.surveyReportType && <div id={`surveyReportType-${this.surveyReportType.id}`} />}
                
                <PVAContentHeader>
                    <div className="row">
                        <div className="col-sm-10 col-md-8 col-xs-12">
                            <div className="title">
                                <span className="hidden-800">{this.state.secondaryReport && this.state.secondaryReport.name} <span className="light">for </span></span>
                                {!this.state.sticky && <PVASelect defaultOptions={defaultOptions} options={this.users} selected={this.state.userId} onChange={(e: any) => this.userChange(e)} />}
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-4 text-right">
                            {this.ActionsButton(false)}
                        </div>
                    </div>
                </PVAContentHeader>
                
                <div ref={(e) => this.banner = e}>
                    {this.state.selectedUserData && <PVANav requireCharacteristics={true} FilterStore={this.props.FilterStore} content={contentHeaderSmall} style={this.getUserStyle()} activeInd={this.state.activeInd} groups={this.state.selectedUserData.inclinationGroups} stickyGroups={this.state.stickyGroups} sticky={this.state.sticky} onSelect={(e: any) => this.updateNav()} />}
                </div>

                <PVAContentBody>
                    {this.state.loading && <LoadingIndicator />}

                    {!this.state.loading && this.state.selectedUserData &&
                        <div>
                            {resultGroups}
                        </div>
                    }
                </PVAContentBody>
            </div>);
    }

    createNote() {
        var note = new SurveyNote();
        note.value = this.state.workingNote;
        note.private = this.state.private;
        this.userDataService.createNote(this.state.selectedUserData.surveyInstanceId, note).then((savedNote: SurveyNote) => {
            var notes = this.state.notes;
            notes.push(savedNote);
            this.setState({
                notes: notes,
                workingNote: ''
            });
        });
    }

    private getUserStyle() {
        if (this.state.selectedUserData && this.state.selectedUserData.style) {
            return this.state.selectedUserData.style;
        }
        return '';
    }

    toggleModal(index: number) {
        let { selectedUserData } = this.state;

        if (index === -1) {
            selectedUserData.responseIndicators.map((ri: any) => {
                ri.showModal = false;
            });
        } else {
            selectedUserData.responseIndicators[index].showModal = !selectedUserData.responseIndicators[index].showModal;
        }

        this.setState({ selectedUserData: selectedUserData });
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/report/Report.tsx